import { render, staticRenderFns } from "./AdminDashboardCustomization.vue?vue&type=template&id=255b0f42&scoped=true"
import script from "./AdminDashboardCustomization.vue?vue&type=script&lang=js"
export * from "./AdminDashboardCustomization.vue?vue&type=script&lang=js"
import style0 from "./AdminDashboardCustomization.vue?vue&type=style&index=0&id=255b0f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b0f42",
  null
  
)

export default component.exports